// New responsive version of panelizr
// TODO/Known bugishness
// 1) What about if there are two links to same content on page?
// 2) refine lightbox (maybe pull into it's own code?)
// 3) better handling of if a panel is open while browser is resized?
// 4) Persist ajax content when resizing

// Dependencies: jQuery, underscore.js

; define('core/ef_plugins/panelizr',["jquery", "core/global/helpers", "core/modules/breakdance", "core/global/leadgen", "underscore", "modernizr", "handlebars", "libs/jquery.bbq", "libs/amplify.core", "core/ef_plugins/spinnerhelper"], function (jQuery, helpers, breakdance, leadgen) {
    (function ($, window, document, undefined) {

        var pluginName = 'panelizr',
            defaults = {
                // GLOBAL SETTINGS USED FOR ALL PANELS
                mainSelector: ".panelizr-main", // OPTIONAL OR USE DEFAULT selector to use to get the "main" page
                lightboxWidth: "420px", // OPTIONAL OR USE DEFAULT width of lightbox on desktop
                setInnerWidth: false, // OPIONAL - If true, we'll set the lightbox's total width to be lightboxWidth + padding. If false, lightbox's total width will be lightboxWidth.
                type: "", // REQUIRED panel type - can be 'inline', 'iframe', 'ajax'
                header: "", // REQUIRED panel header text
                subheader: "", // REQUIRED panel sub-header text
                headerContent: "", // OPTIONAL - jQuery selector for additional content to be displayed in .panel-header, below subheader.
                panelName: "", // REQUIRED unique ID to use to identify this panel (no spaces or special characters!)
                panelClasses: "", // OPTIONAL One or more space-separated CSS Class names to be applied to the panel, along with the standard Panelizr class names.
                lightboxAnim: false, // OPTIONAL Should we animate the opening of the lightbox?
                context: "ALL", // OPTIONAL: can be "MOBILE" "DESKTOP" or "ALL" - whether to use a panel on just mobile, a lightbox on just desktop, or a mobile panel & desktop lightbox
                urlData: {}, // OPTIONAL: Obj of key/value pairs to merge in to url (only used in ajax or iframe)
                // will assume mobile for inline content and all for ajax content
                contextSwitch: 480, // OPTIONAL - width at which to switch from mobile to desktop behavior
                // INLINE PANEL SETTINGS
                placeholderElementClass: "panelizr-placeholder", // OPTIONAL config of placeholder element used for inline panels
                // AJAX PANEL SETTINGS
                ajaxLoadUrlFragment: "", // OPTIONAL - An ID to select only a portion of the remote page to insert intot the ajax panel.
                ajaxLoadCallback: function () { }, // OPTIONAL - the callback to fire after the panel loads
                ajaxAlwaysReload: "false", // OPTIONAL - boolean flag to force ajax content to reload every time
                ajaxPanelLoadHeight: "200px", // OPTIONAL - height to set empty panel body to display spinner while loading
                closeCallback: function () { }, // OPTIONAL - the callback to fire after the panel closes
                useBrowserHistory: "true",
                ajaxLoadImmediately: "false", // OPTIONAL - should the content be loaded immediately into the panel
                // IFRAME PANEL SETTINGS
                iframeHeight: 100 % "", //container height -- set in sitecore for hoverbox
                iframeUrl: "", // OPTIONAL - url to load into the iframe (if this doesn't exist use the href of the a tag)               
                focusTarget: "", //OPTIONAL - element to set focus on
                // CTA OPTIONS
                ctaInPanel: false, //OPTIONAL - is there a CTA in the panel that will require a panel refresh?
                ctaUrl: "", //OPTIONAL - url for the CTA
                ctaClass: "", //OPTIONAL - class of the div to place the CTA form in
                ctaInMiddle: false, //OPTIONAL - will the CTA be in the middle of the panel?
                // TWO-STEP EXPANDO
                twoStepExpando: false, //OPTIONAL - is this going to be one of our new-fangled expando forms?
                // STYLING
                useNewStyling: false, //OPTIONAL -- use the updated panelizr form styling
                // SWIPE GALLERY
                swipeGallery: false, //OPTIONAL -- is this a gallery of images?
                // TOUR CONSULTANT SECTION
                includeTcSection: "false" //OPTIONAL -- include Tour Consultant section?
            };

        // The actual plugin constructor
        function Panelizr(element, options) {
            // save element this was called on
            this.element = element;
            this.$element = $(element);

            // get per-element inline configuration settings
            this.metadata = this.$element.data('panelizr-options');

            // merge all the configs
            this.options = $.extend({}, defaults, options, this.metadata);

            this._defaults = defaults;
            this._name = pluginName;

            // set open flag
            this.isOpen = false;

            // set use browser history flag (can not use custom browser history in < IE10)
            this.options.useBrowserHistory = helpers.toBool(this.options.useBrowserHistory) && Modernizr.history;
            this.options.ajaxAlwaysReload = helpers.toBool(this.options.ajaxAlwaysReload);
            this.options.ajaxLoadImmediately = helpers.toBool(this.options.ajaxLoadImmediately);
            this.options.setInnerWidth = helpers.toBool(this.options.setInnerWidth);
            this.options.lightboxAnim = helpers.toBool(this.options.lightboxAnim);

            // set these config values to uppercase
            this.options.context = this.options.context.toUpperCase();
            this.options.type = this.options.type.toUpperCase();

            // set context to default if not defined
            switch (this.options.type) {
                case "AJAX":
                case "IFRAME":
                    // if no explicit context passed in, set to default of ALL
                    this.options.context = this.options.context || "ALL";
                    break;

                case "INLINE":
                    // if no explicit context passed in, set to default of MOBILE ONLY
                    this.options.context = this.options.context || "MOBILE";
                    break;

                default:
                    throw new Error("whoops, forgot to define a type, exiting now");
            }

            // get the main element
            this.$main = $(this.options.mainSelector);

            // other vars to be used later
            this.$placeholder = this.$target = this.$panel = this.$panelBody = this.$panelCloseButton = this.$panelOverlay = this.$lightbox = this.$iframe = this.$ctaBody = this.$tcSection = $();
            this.target = "";
            this._currentContext = "";

            // let's do this
            this.init();
        }

        Panelizr.prototype = {

            init: function () {
                var plugin = this;

                // set current context (mobile or desktop)
                plugin._currentContext = plugin._getBrowserContext();

                // Workaround for CSK-798. Chrome jumps to the top of the page when we use history to open the popup.
                // On mobile, this may happen too, but we can't see it because the popup fills the viewport. When the
                // popup is closed, we scroll back to the correct location.
                plugin.options.useBrowserHistory = plugin.options.useBrowserHistory && plugin._isMobileContext();

                // if the context matches the context setting for the plugin, continue setup
                if (plugin._isCurrentContextValid()) {

                    // create the panel or the lightbox
                    plugin._setupPanelOrLightbox();

                    // setup the content that goes in the panel or lightbox
                    plugin._setupType();

                    // setup listeners
                    plugin._openClickListen();
                    plugin._historyListen();
                    // Check if AJAX content should be loaded along with page load
                    if (plugin.options.type === 'AJAX' && plugin.options.ajaxLoadImmediately) {
                        plugin._ajaxLoad();
                    }
                }
                this._resizeListen();
            },

            // get the current browser context (mobile or desktop) based on context switch pixel width value
            _getBrowserContext: function () {
                var plugin = this,
                    bp = window.innerWidth;
                return (bp <= plugin.options.contextSwitch) ? "MOBILE" : "DESKTOP";
            },

            // context checking utilities
            _isMobileContext: function () {
                var plugin = this;
                return plugin._currentContext === "MOBILE";
            },

            _isDesktopContext: function () {
                var plugin = this;
                return plugin._currentContext === "DESKTOP";
            },

            _isContextChanged: function () {
                var plugin = this;
                return plugin._getBrowserContext() !== plugin._currentContext;
            },

            // check if the current browser context matches the settings for the plugin
            _isCurrentContextValid: function () {
                var plugin = this;
                return (plugin.options.context === "ALL" ||
                (plugin._isMobileContext() && plugin.options.context === "MOBILE") ||
                (plugin._isDesktopContext() && plugin.options.context === "DESKTOP"));
            },

            _isMobileContextValid: function () {
                var plugin = this;
                return (plugin._currentContext === "MOBILE" && (plugin.options.context === "ALL" || plugin.options.context === "MOBILE"));
            },

            _isDesktopContextValid: function () {
                var plugin = this;
                return (plugin._currentContext === "DESKTOP" && (plugin.options.context === "ALL" || plugin.options.context === "DESKTOP"));
            },

            // setup the panel or lightbox according to the current browser context
            _setupPanelOrLightbox: function () {
                var plugin = this;

                if (plugin._isMobileContext()) {
                    // create the panel
                    plugin._createPanel();

                    // insert panel into doc
                    plugin.$main.after(plugin.$panel);
                } else if (plugin._isDesktopContext()) {
                    // do lightbox stuff
                    plugin._createLightbox();

                    // insert into doc
                    plugin.$main.after(plugin.$lightbox);

                    // Set width
                    plugin._setLightboxWidth();

                    // Kick off animation
                    plugin._animateLightbox();

                }

            },

            _setupType: function () {
                var plugin = this;

                switch (plugin.options.type.toUpperCase()) {
                    case "AJAX":
                        // do the setup
                        plugin._ajaxSetup();
                        break;

                    case "INLINE":
                        // do the setup
                        plugin._inlineSetup();
                        break;

                    case "IFRAME":
                        // do the setup
                        plugin._iframeSetup();
                        break;

                    default:
                        throw new Error("whoops, forgot to define a type, exiting now");
                }
            },

            _resizeListen: function () {
                var plugin = this;

                if (!$('html').hasClass('lt-ie9')) {
                    var resetAndInit = _.debounce(function () {
                        if (plugin._isContextChanged()) {

                            // reset everything
                            plugin._close();
                            plugin._reset();

                            // re-initialize
                            plugin.init();
                        }
                    }, 300);

                    // register breakpoint with enquire js
                    breakdance.register(plugin.options.contextSwitch, resetAndInit, resetAndInit);
                }

            },


            _inlineSetup: function () {
                var plugin = this;

                // placeholder element to put in where the content was
                plugin.$placeholder = $('<div/>').attr({ 'class': plugin.options.placeholderElementClass, 'style': 'display:none;', 'name': plugin.options.panelName });

                // get target element
                plugin.target = this.$element.attr('href');
                plugin.$target = $(this.target);

                // insert placeholder after target & remove target from dom
                plugin.$target.after(plugin.$placeholder);
                plugin.$target.detach();

                // stuff target into panel body
                plugin.$panelBody.append(plugin.$target);
            },

            _tcSectionSetup: function () {
                var plugin = this;
                var $tcSectionContent = $("#tcFormSection");

                $tcSectionContent.detach();
                plugin.$tcSection.append($tcSectionContent);
            },

            _ajaxSetup: function () {
                var plugin = this;

                // set the url to load - if the explicit option isn't set, use the href of the element
                //plugin.options.ajaxLoadUrl = plugin.options.ajaxLoadUrl || plugin.$element.attr('href');

                // check that the callback passed in is really a function & handle namespaced functions
                if (plugin.options.ajaxLoadCallback && !(typeof plugin.options.ajaxLoadCallback === "function")) {
                    plugin.options.ajaxLoadCallback = helpers.getFuncFromString(plugin.options.ajaxLoadCallback);
                }

                // as of now, we don't load content until the link is clicked, so we don't append the content in
                // maybe in the future we might want to make this a config setting?
            },

            _iframeSetup: function () {
                var plugin = this;

                // set the url to load - if not explicitly set, use the href of the element
                plugin.options.iframeUrl = plugin.options.iframeUrl || plugin.$element.attr('href');

                // create the iframe and append to body
                plugin.$iframe = $('<iframe />', {
                    height: plugin.options.iframeHeight,
                    width: '100%',
                    frameBorder: '0'
                }).appendTo(plugin.$panelBody);

            },

            _createPanel: function () {
                var plugin = this,
                    panelTemplate,
                    noHeader,
                    noSubheader,
                    context,
                    template,
                    html;

                // handlebars template
                if (plugin.options.ctaInPanel && plugin.options.ctaUrl != "") {
                    panelTemplate = '<div class="panel panelizr {{noHeaderClass}} {{panelClasses}} {{expandoClass}} {{backgroundStyle}} {{ctaInMiddle}} {{tcSectionClass}}" id="{{panelName}}"> \
                                    <header class="panel-header {{noSubheaderClass}}"> \
                                        {{#headerText}} <h2>{{this}}</h2> {{/headerText}} \
                                        {{#subheaderText}} <h3>{{this}}</h3> {{/subheaderText}} \
                                        {{#headerContent}} <div class="panel-header-content">{{this}}</div> {{/headerContent}} \
                                        {{#tcSection}} <div class="panel-tour-consultant-section"></div> {{/tcSection}} \
                                        <a href="#" class="panel-close" id="panel-close">X</a> \
                                    </header> \
                                    <div class="panel-body" id="{{panelName}}-body"></div> \
                                    <div class="cta-body" id="{{panelName}}-cta-body"></div> \
                                </div>';
                } else {
                    panelTemplate = '<div class="panel panelizr {{noHeaderClass}} {{panelClasses}} {{expandoClass}} {{backgroundStyle}} {{tcSectionClass}}" id="{{panelName}}"> \
                                    <header class="panel-header {{noSubheaderClass}}"> \
                                        {{#headerText}} <h2>{{this}}</h2> {{/headerText}} \
                                        {{#subheaderText}} <h3>{{this}}</h3> {{/subheaderText}} \
                                        {{#headerContent}} <div class="panel-header-content">{{this}}</div> {{/headerContent}} \
                                        {{#tcSection}} <div class="panel-tour-consultant-section">{{this}}</div> {{/tcSection}} \
                                        <a href="#" class="panel-close" id="panel-close">X</a> \
                                    </header> \
                                    <div class="panel-body" id="{{panelName}}-body"></div> \
                                </div>';
                };

                // setup obj of values to pass to template
                noHeader = (plugin.options.header == "" && plugin.options.subheader == "") ? "no-header" : "";
                noSubheader = plugin.options.subheader == "" ? "no-subheader" : "";

                context = {
                    noHeaderClass: noHeader,
                    noSubheaderClass: noSubheader,
                    headerText: plugin.options.header != '' ? plugin.options.header : undefined,
                    subheaderText: plugin.options.subheader != '' ? plugin.options.subheader : undefined,
                    headerContent: $(plugin.options.headerContent).html(),
                    tcSection: plugin.options.includeTcSection == "true" ? "" : undefined,
                    tcSectionClass: plugin.options.includeTcSection == "true" ? "has-tc-section" : undefined,
                    panelName: plugin.options.panelName,
                    panelClasses: plugin.options.panelClasses,
                    platform: plugin.options._currentContext,
                    expandoClass: plugin.options.twoStepExpando ? "expando-form" : undefined,
                    backgroundStyle: plugin.options.useNewStyling ? "with-background" : undefined,
                    ctaInMiddle: plugin.options.ctaInMiddle ? "cta-in-middle" : undefined
                };

                // render handlebars template
                template = Handlebars.compile(panelTemplate);
                html = template(context);
                plugin.$panel = $(html).hide();

                // save refs to panel pieces
                plugin.$panelBody = plugin.$panel.find('.panel-body');
                plugin.$panelCloseButton = plugin.$panel.find('#panel-close');
                plugin.$ctaBody = plugin.$panel.find('.cta-body');
                plugin.$tcSection = plugin.$panel.find('.panel-tour-consultant-section');


                // setup tour consultant section
                if (plugin.options.includeTcSection == "true") {
                    plugin._tcSectionSetup();
                }

                // setup close button listener
                plugin._closeClickListen();
            },

            _createLightbox: function () {
                var plugin = this,
                    lightboxTemplate,
                    noHeader,
                    noSubheader,
                    context,
                    template,
                    html;

                // handlebars template
                if (plugin.options.ctaInPanel && plugin.options.ctaUrl != "") {
                    lightboxTemplate = '<div class="lightbox-overlay panelizr-lightbox panelizr-{{panelizrType}}" id="{{panelName}}-lightbox"> \
                                    <div class="lightbox-content panel panelizr {{noHeaderClass}} {{panelClasses}} {{expandoClass}} {{backgroundStyle}} {{tcSectionClass}}" id="{{panelName}}"> \
                                        <header class="panel-header lightbox-header {{noSubheaderClass}}"> \
                                            {{#headerText}} <h2>{{this}}</h2> {{/headerText}} \
                                            {{#subheaderText}} <h3>{{this}}</h3> {{/subheaderText}} \
                                            {{#headerContent}} <div class="panel-header-content">{{this}}</div> {{/headerContent}} \
                                            {{#tcSection}} <div class="panel-tour-consultant-section">{{this}}</div> {{/tcSection}} \
                                            <a href="#" class="lightbox-close" id="lightbox-close">X</a> \
                                        </header> \
                                        <div class="panel-body lightbox-body" id="{{panelName}}-body"></div> \
                                        <div class="cta-body" id="{{panelName}}-cta-body"></div> \
                                    </div> \
                                </div>';
                } else {
                    lightboxTemplate = '<div class="lightbox-overlay panelizr-lightbox panelizr-{{panelizrType}}" id="{{panelName}}-lightbox"> \
                                    <div class="lightbox-content panel panelizr {{noHeaderClass}} {{panelClasses}} {{expandoClass}} {{backgroundStyle}} {{tcSectionClass}}" id="{{panelName}}"> \
                                        <header class="panel-header lightbox-header {{noSubheaderClass}}"> \
                                            {{#headerText}} <h2>{{this}}</h2> {{/headerText}} \
                                            {{#subheaderText}} <h3>{{this}}</h3> {{/subheaderText}} \
                                            {{#headerContent}} <div class="panel-header-content">{{this}}</div> {{/headerContent}} \
                                            {{#tcSection}} <div class="panel-tour-consultant-section">{{this}}</div> {{/tcSection}} \
                                            <a href="#" class="lightbox-close" id="lightbox-close">X</a> \
                                        </header> \
                                        <div class="panel-body lightbox-body" id="{{panelName}}-body"></div> \
                                    </div> \
                                </div>';
                };

                // setup obj of values to pass to template
                noHeader = (plugin.options.header == "" && plugin.options.subheader == "") ? "no-header" : "";
                noSubheader = plugin.options.subheader == "" ? "no-subheader" : "";
                context = {
                    noHeaderClass: noHeader,
                    noSubheaderClass: noSubheader,
                    headerText: plugin.options.header != '' ? plugin.options.header : undefined,
                    subheaderText: plugin.options.subheader != '' ? plugin.options.subheader : undefined,
                    headerContent: $(plugin.options.headerContent).html(),
                    tcSection: plugin.options.includeTcSection == "true" ? "" : undefined,
                    tcSectionClass: plugin.options.includeTcSection == "true" ? "has-tc-section" : undefined,
                    panelName: plugin.options.panelName,
                    panelizrType: plugin.options.type.toLowerCase(),
                    panelClasses: plugin.options.panelClasses,
                    platform: plugin.options._currentContext,
                    expandoClass: plugin.options.twoStepExpando == "true" ? "expando-form" : undefined,
                    backgroundStyle: plugin.options.useNewStyling == "true" ? "with-background" : undefined
                };

                template = Handlebars.compile(lightboxTemplate);
                html = template(context);
                plugin.$lightbox = $(html).hide();

                // save refs to panel pieces
                plugin.$panel = plugin.$lightbox.find('.panel');
                plugin.$panelBody = plugin.$panel.find('.panel-body');
                plugin.$panelCloseButton = plugin.$panel.find('#lightbox-close');
                plugin.$panelOverlay = plugin.$lightbox.closest('.lightbox-overlay');
                plugin.$ctaBody = plugin.$panel.find('.cta-body');
                plugin.$tcSection = plugin.$panel.find('.panel-tour-consultant-section');

                // setup tour consultant section
                if (plugin.options.includeTcSection == "true") {
                    plugin._tcSectionSetup();
                }

                // setup close button listener
                plugin._closeClickListen();

                // Kick off animation
                plugin._animateLightbox();
            },


            _ctaListener: function (ctaId, ctaInMiddle) {
                var plugin = this;
                var $ctaDiv = plugin.$panelBody.find(".panel-expand-cta[data-attribute-cta=" + ctaId + "]");
                if ($ctaDiv.hasClass("listening")) return;
                $ctaDiv.addClass("listening");
                $ctaDiv.on("click",function () {
                    $(this).toggleClass("is-active");
                    if (ctaInMiddle) {
                        $(this).next(".cta-body").slideToggle();
                    } else {
                        $(this).closest(".panel-body").next(".cta-body").slideToggle();
                    }
                });
            },

            _setLightboxWidth: function () {
                var plugin = this;
                // This is separate from createLightbox because we can only do these height calculations
                // after the panel has been inserted into the DOM. This function is not called for panels.
                plugin.$panel.width(plugin.options.lightboxWidth);
                if (plugin.options.setInnerWidth) {
                    plugin.$panel
                        .css('width', '+=' + plugin.$panelBody.css('padding-left'))
                        .css('width', '+=' + plugin.$panelBody.css('padding-right'));
                }
            },

            _animateLightbox: function () {
                var plugin = this;

                // exit if option isn't set to true
                if (!plugin.options.lightboxAnim) return;

                plugin.$panelOverlay.addClass("lightbox-anim");
                // We have to do this after we set the width, or some browsers won't run the animation at all.
                // We may eventually add more animation code to this function.
            },

            _closeClickListen: function () {
                var plugin = this;

                // add click listener to close button
                plugin.$panelCloseButton.on('click.panelizr.' + plugin.options.panelName, function (event) {
                    event.preventDefault();
                    plugin.close();
                });

                // click outside lightwindow to close
                if (plugin.$lightbox.length > 0) {
                    plugin.$panelOverlay.on('click.panelizr.' + plugin.options.panelName, function (event) {
                        if ($(event.target).hasClass('lightbox-overlay')) {
                            plugin.close();
                        }
                    });
                }

                // Press escape to close
                $(document).on('keydown.panelizr.' + plugin.options.panelName, function (event) {
                    if (event.keyCode === 27) { // Escape key
                        plugin.close();
                    }
                });
            },

            _openClickListen: function () {
                var plugin = this;
                plugin.$element.on('click.panelizr.' + plugin.options.panelName, function (event) {
                    // If the browser isn't big enough for the lightbox, don't display the popup.                    
                    var outerWidth= Math.round(plugin.$panel.outerWidth());
                    if (document.documentElement.clientWidth < (outerWidth)) {
                        return;
                    }
                    event.preventDefault();
                    plugin.open(true);
                });
            },

            // setup browser history back listener
            _historyListen: function () {
                var plugin = this;

                if (!plugin.options.useBrowserHistory) { // Turn around and go home IE9. And take your little brothers with you.
                    return;
                }

                //add popstate listener to window
                $(window).on('popstate.panelizr.' + plugin.options.panelName, function (event) {
                    event.preventDefault();
                    if (event.originalEvent.state && event.originalEvent.state.panelizr
                        && event.originalEvent.state.panelizr.panelName === plugin.options.panelName) {

                        switch (event.originalEvent.state.panelizr.action) {
                            case "open":
                                plugin.open(false);
                                break;
                            case "close":
                                plugin._close(event.originalEvent.state.panelizr.scrollTo);
                        }
                    }
                });
            },

            open: function (pushIt) {
                var plugin = this,
                    viewportYOffset;
                pushIt = (typeof pushIt !== "undefined") ? pushIt : true;

                // exit if already open
                if (plugin.isOpen) return;

                // browser history state
                if (pushIt && plugin.options.useBrowserHistory) {
                    // save the main page to history
                    history.replaceState({ panelizr: { panelName: plugin.options.panelName, action: 'close', scrollTo: $(window).scrollTop() } }, '');

                    // add new history entry for the current panel
                    history.pushState({ panelizr: { panelName: plugin.options.panelName, action: 'open' } }, '');
                }

                if (plugin.options.focusTarget) {
                    setTimeout(function () {
                        var $focusTarget = plugin.$panel.find(plugin.options.focusTarget).first();
                        $focusTarget.focus();
                        $focusTarget.select();
                    }, 20);
                }

                if (plugin._isMobileContextValid()) {
                    // show panel, hide main
                    plugin.$panel.show(0, function () {
                        // scroll to top of panel
                        window.scrollTo(0, 1);
                    });
                    plugin.$main.hide();
                } else if (plugin._isDesktopContextValid()) {
                    // show as lightbox
                    plugin.$lightbox.show();

                    // Move lightwindow into viewport 
                    // Offset will be undefined in IE. We're also null checking it, just to be safe.
                    if (!_.isNull(window.pageYOffset) && !_.isUndefined(window.pageYOffset)) {
                        viewportYOffset = window.pageYOffset;
                    } else {
                        viewportYOffset = window.document.documentElement.scrollTop;
                    }
                    plugin.$panel.css('margin-top', (viewportYOffset + 20) + 'px');
                }


                // if there's a CTA and it's inline, load that
                if (plugin.options.ctaInPanel && plugin.options.ctaUrl != "" && plugin.options.type == "INLINE") {
                    plugin._ctaLoad();
                }

                // load in ajax content
                if ((plugin.options.type === 'AJAX' && !plugin.options.ajaxLoadImmediately) || plugin.options.swipeGallery === "true") {
                    plugin._ajaxLoad();
                }

                // load in iframe content
                if (plugin.options.type === "IFRAME") {
                    plugin.$iframe.attr('src', $.param.querystring(plugin.options.iframeUrl, plugin.options.urlData));
                }

                // check if the tc panel exists on the page, and hide it if the panalizer pnel opens (so the tc panel isn't on top)
                var $tourConsultantInfoPanel = $('#tour-consultant-container');
                if ($tourConsultantInfoPanel.length !== 0) {
                    $tourConsultantInfoPanel.hide();
                }

                // Butter Prototype, DELETE AFTER INITIAL BUTTER PROTOTYPE 2018
                document.body.classList.add("in-panelizr-panel")

                // set flag
                plugin.isOpen = true;
                // publish open event
                amplify.publish("modal/open");

                // fire form load GA event
                var formName = plugin.$panel.attr("id");
                dataLayer.push({ 'event': 'load', 'context': formName, 'pageType': 'virtual' });
            },

            _ajaxLoad: function ($this) {
                var plugin = this,
                    url,
                    panelData = plugin.$panel.data('panelizr-ajax-panel') || { loadStatus: '', panelName: plugin.options.panelName },
                    spinner;

                // don't load content if something is already loaded, unless always reload flag is true
                if ((panelData.loadStatus !== 'started' && panelData.loadStatus !== 'complete') || (plugin.options.ajaxAlwaysReload && !plugin.options.ajaxLoadImmediately)) {
                    // remove any existing content
                    plugin.$panelBody.empty();
                    plugin.$panelBody.height(plugin.options.ajaxPanelLoadHeight);

                    // insert a spinner
                    if (plugin._isMobileContext()) {
                        spinner = plugin.$panelBody.spinnerhelper({ 'type': 'inline', 'delay': 0, spinOpts: { lines: 11, width: 3, scale: .5, top: '17%' } }).data('plugin_spinnerhelper');
                    } else {
                        spinner = plugin.$panelBody.spinnerhelper({ 'type': 'inline', 'delay': 0 }).data('plugin_spinnerhelper');
                    }

                    // set load status & updated panel Data
                    panelData.loadStatus = 'started';
                    plugin.$panel.data('panelizr-ajax-panel', panelData);

                    // set up the url, merge the urlData into the url and add the fragment identifier
                    url = $.param.querystring(plugin.$element.attr('href'), plugin.options.urlData);
                    url = plugin.options.ajaxLoadUrlFragment ? url + " " + plugin.options.ajaxLoadUrlFragment : url;

                    // load the content into the panel 

                    plugin.$panelBody.load(url, function (responseText, textStatus, XMLHttpRequest) {
                        if (plugin.options.ctaInPanel && plugin.options.ctaUrl != "") {
                            plugin._ctaLoad();
                        }
                        spinner.destroy();
                        plugin.$panelBody.height('auto');

                        switch (textStatus) {
                            case "success":
                                panelData.loadStatus = "complete";
                                plugin.options.ajaxLoadCallback(plugin.$panel, responseText, textStatus, XMLHttpRequest, plugin.options.ctaInPanel);
                                amplify.publish("panelizr/ajaxLoadComplete");
                                if (plugin.options.twoStepExpando) {
                                    leadgen.expandoForm();
                                }

                                if (plugin.options.swipeGallery) {
                                    panelData.loadStatus = "";
                                    EFTOURS.gallery.galleryInit(plugin.$panel, responseText, textStatus, XMLHttpRequest);
                                }
                                break;

                            case "error":
                            case "timeout":
                            case "abort":
                            case "parsererror":
                                panelData.loadStatus = "error";
                                if ($('body').hasClass("ETFC"))
                                    plugin.$panelBody.text('Oups, une erreur s’est produite. Merci de réessayer un peu plus tard.');
                                else
                                    plugin.$panelBody.text('Oops, there has been an error. Please try again later');
                        }

                        // reset the panel data
                        plugin.$panel.data('panelizr-ajax-panel', panelData);
                    });
                }
            },

            _ctaLoad: function ($this) {
                var plugin = this,
                    url,
                    panelData = plugin.$panel.data('panelizr-ajax-panel') || { loadStatus: '', panelName: plugin.options.panelName };

                // remove any existing content
                plugin.$ctaBody.empty();
                plugin.$ctaBody.height(plugin.options.ajaxPanelLoadHeight);

                // set load status & updated panel Data
                panelData.loadStatus = 'started';

                // set up the url, merge the urlData into the url and add the fragment identifier
                url = plugin.options.ctaUrl;

                var $thisCta = $(plugin.$panelBody).find(".panel-expand-cta");
                if (plugin.options.ctaInMiddle) {
                    plugin.$ctaBody.detach().insertAfter($thisCta);
                }
                plugin._ctaListener($thisCta.attr("data-attribute-cta"), plugin.options.ctaInMiddle);

                // load the content into the panel 
                plugin.$ctaBody.load(url, function (responseText, textStatus, XMLHttpRequest) {
                    plugin.$ctaBody.height('auto');

                    switch (textStatus) {
                        case "success":
                            panelData.loadStatus = "complete";
                            EFTOURS.leadforms.leadFormInit(plugin.$panel, responseText, textStatus, XMLHttpRequest, plugin.options.ctaInPanel);
                            amplify.publish("panelizr/ajaxLoadComplete");
                            break;

                        case "error":
                        case "timeout":
                        case "abort":
                        case "parsererror":
                            panelData.loadStatus = "error";
                            if ($('body').hasClass("ETFC"))
                                plugin.$ctaBody.text('Oups, une erreur s’est produite. Merci de réessayer un peu plus tard.');
                            else
                                plugin.$panelBody.text('Oops, there has been an error. Please try again later');
                    }

                    // reset the panel data
                    plugin.$panel.data('panelizr-ajax-panel', panelData);
                });
            },

            close: function () {
                var plugin = this;

                if (plugin.isOpen) {
                    // the public function just sends the browser history back
                    if (plugin.options.useBrowserHistory) {
                        history.go(-1);
                    } else {
                        plugin._close(0);
                    }
                }
            },

            _close: function (scrollTo) {
                // the private function does the real closing stuff
                var plugin = this;

                // exit if already closed
                if (!plugin.isOpen) return;

                if (plugin.options.ajaxAlwaysReload && !plugin.options.ajaxLoadImmediately) {
                    if (plugin.options.ctaInPanel && plugin.options.ctaUrl != "") {
                        plugin.$ctaBody.empty();
                    } else {
                        plugin.$panelBody.empty();
                    }
                }

                if (plugin._isMobileContextValid()) {
                    // do the show/hide stuff
                    plugin.$main.show();
                    plugin.$panel.hide(0, function () {
                        // scroll down to the link
                        $(window).scrollTop(scrollTo);
                    });
                } else if (plugin._isDesktopContextValid()) {
                    //  close lightbox
                    plugin.$lightbox.hide();
                }

                if (plugin.options.ctaInPanel && plugin.options.ctaUrl != "") {
                    $(plugin.$ctaBody).hide();
                }

                // check if the tc panel exists on the page, and hide it if the panalizer pnel opens (so the tc panel isn't on top)
                var $tourConsultantInfoPanel = $('#tour-consultant-container');
                if ($tourConsultantInfoPanel.length !== 0) {
                    $tourConsultantInfoPanel.show();
                }

                // Butter Prototype, DELETE AFTER INITIAL BUTTER PROTOTYPE 2018
                document.body.classList.remove("in-panelizr-panel")

                dataLayer.push({ 'event': 'click', 'action': 'close', 'pageType': '' });

                // set flag
                plugin.isOpen = false;

                // check that the callback passed in is really a function & handle namespaced functions
                if (plugin.options.closeCallback && !(typeof plugin.options.closeCallback === "function")) {
                    plugin.options.closeCallback = helpers.getFuncFromString(plugin.options.closeCallback);
                }
                plugin.options.closeCallback();

                // kill the gallery if there is one
                if (plugin.options.swipeGallery) {
                    EFTOURS.gallery.galleryClose();
                }

                amplify.publish("modal/close");
            },

            // reset the plugin but don't destroy the outer Panelizr js object
            _reset: function () {
                var plugin = this;

                // if the panel is open, close it
                if (plugin.isOpen) {
                    if (plugin.options.useBrowserHistory) {
                        history.go(-1);
                    } else {
                        plugin._close(0);
                    }
                }

                // remove listeners
                if (!plugin.options.useBrowserHistory) {
                    $(window).off('popstate.panelizr.' + plugin.options.panelName);
                }
                plugin.$element.off('click.panelizr.' + plugin.options.panelName);
                plugin.$panelCloseButton.off('click.panelizr.' + plugin.options.panelName);


                // for inline panels, put the content back where it was
                if (plugin.options.type === "INLINE") {
                    plugin.$target.detach().insertAfter(plugin.$placeholder);
                    plugin.$placeholder.remove();
                }

                // destroy the panel or lightbox
                if (plugin.$panel.length > 0) {
                    plugin.$panel.remove();
                }
                if (plugin.$lightbox.length > 0) {
                    plugin.$lightbox.remove();
                }
            },

            // completely destroy the plugin & it's object
            destroy: function () {
                var plugin = this;

                plugin._reset();

                // remove the data
                plugin.$element.removeData('plugin_' + pluginName);
            }
        };

        // A really lightweight plugin wrapper around the constructor,
        // preventing against multiple instantiations
        $.fn[pluginName] = function (options) {
            return this.each(function () {
                if (!$.data(this, 'plugin_' + pluginName)) {
                    $.data(this, 'plugin_' + pluginName,
                        new Panelizr(this, options));
                }
            });
        }

    })(jQuery, window, document);
});

